import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Input,
  Typography
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper";
import RequestHandler from "util/RequestHandler";

const ProjectStepListFilter = (props) => {
  const [form] = Form.useForm();
  const [projectStepSelect, setProjectStepSelect] = useState({
    data: [],
    loading: false,
  });
  const [projectStatusSelect, setProjectStatusSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getProjectStatus();
  }, []);

  const getProjectStatus = () => {
    setProjectStatusSelect({ data: [], loading: true });

    RequestHandler.get(`/ProjectStep/GetProjectStatus`).then((res) => {
      setProjectStatusSelect({ data: res, loading: false });
    });
  };

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        conditions.push(`id eq ${values.id}`);
      }
      if (values.status) {
        conditions.push(`statusByte eq ${values.status}`);
      }
      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }
      if (values.startDate) {
        conditions.push(
          odata.dateCompareValueBefore(values.startDate, "eq", "startDate")
        );
      }
      if (values.endDate) {
        conditions.push(
          odata.dateCompareValueBefore(values.endDate, "eq", "endDate")
        );
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const onStockSearch = (value) => {
    if (value.length >= 2) {
      setProjectStepSelect({ data: [], loading: true });

      RequestHandler.get(
        `/ProjectStep/${
          props.firmId
        }?$select=id,name,description&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("description", value)})`
      ).then((res) => {
        setProjectStepSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectStepSelect({ data: [], loading: false });
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label=" Ad :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onStockSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectStepSelect.loading}
                    >
                      {projectStepSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          description={item.description}
                        >
                          {item.name + " (" + item.description + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Durum" name="status">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectStatusSelect.loading}
                    >
                      {projectStatusSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Başlangıç Tarihi" name="startDate">
                    <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Bitiş Tarihi" name="endDate">
                    <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default ProjectStepListFilter;
